var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"parking"}},[_c('BarChart',{staticClass:"parking",attrs:{"chartData":_vm.parkingChartData,"options":_vm.parkingChartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }